import React, {StrictMode} from 'react';
import Datos from './components/Datos'
import FormularioChat from './components/FormularioChat';
import {ContenidoPrincipal} from './components/css/estilos'
import 'bootstrap/dist/css/bootstrap.min.css';




const App = () => {
  return ( 
    <StrictMode>
      <div className="col-12 col-sm-10 col-md-9 col-lg-6">
      <ContenidoPrincipal>
        <h2 style={{color : "white"}}>Anonymous Random Chat</h2>
        <FormularioChat/>
        <Datos />
      </ContenidoPrincipal>
      </div>
    </StrictMode>
   );
}

export default App;